module.exports = __webpack_public_path__ + "static/media/IC_design_led_materiality_projects.4dfc1e41.svg";